import * as MutationTypes from './mutation-types'
import CirurgiaService from '@/services/cirurgia-service'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'

export default {
  state: {
    solicitacaoCirurgia: null,
    solicitacoesCirurgia: null
  },

  getters: {
    solicitacaoCirurgia: (state) => state.solicitacaoCirurgia,
    solicitacoesCirurgia: (state) => state.solicitacoesCirurgia
  },

  mutations: {
    [MutationTypes.SET_SOLICITACOES_CIRURGIA](state, value) {
      state.solicitacoesCirurgia = value
    },
    [MutationTypes.SET_SOLICITACAO_CIRURGIA](state, value) {
      state.solicitacaoCirurgia = value
    }
  },

  actions: {
    async getSolicitacoesCirurgia({ commit }) {
      await CirurgiaService.getSolicitacoes()
        .then((res) => {
          if (!res.ok) {
            if (res.status === 401) throw new NotAuthenticatedError()

            throw new Error(`HTTP error, status ${res.status}`)
          }
          const t = res.text

          if (!t?.length) return []

          return JSON.parse(t)
        })
        .then((data) => {
          commit(MutationTypes.SET_SOLICITACOES_CIRURGIA, data)
        })
        .catch((err) => {
          throw err
        })
    },

    async getSolicitacaoCirurgia({ commit }, cirurgia) {
      await CirurgiaService.getSolicitacao(
        cirurgia.DtHrSolicitacao,
        cirurgia.CdCirurgia
      )
        .then((res) => {
          if (!res.ok) {
            if (res.status === 401) throw new NotAuthenticatedError()

            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.json()
        })
        .then((data) => {
          if (data && data.length > 0) {
            commit(MutationTypes.SET_SOLICITACAO_CIRURGIA, data[0])
          } else {
            commit(MutationTypes.SET_SOLICITACAO_CIRURGIA, data)
          }
        })
        .catch((err) => {
          throw err
        })
    }
  }
}
